 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML03_MAP from '@/components/xhtml/03_Map'
 import XHTML04_NOTE from '@/components/xhtml/04_Note'
 import XHTML05_ACKNOWLEDGEMENTS from '@/components/xhtml/05_Acknowledgements'
 import XHTML06_GLOSSARY from '@/components/xhtml/06_Glossary'
 import XHTML07_BRIEF from '@/components/xhtml/07_Brief'
 import XHTML08_OPOR from '@/components/xhtml/08_Opor'
 import XHTML09_MILITARY from '@/components/xhtml/09_Military'
 import XHTML10_CHAPTER_001 from '@/components/xhtml/10_Chapter_001'
 import XHTML11_CHAPTER_002 from '@/components/xhtml/11_Chapter_002'
 import XHTML12_CHAPTER_003 from '@/components/xhtml/12_Chapter_003'
 import XHTML13_CHAPTER_004 from '@/components/xhtml/13_Chapter_004'
 import XHTML14_CHAPTER_005 from '@/components/xhtml/14_Chapter_005'
 import XHTML15_CHAPTER_006 from '@/components/xhtml/15_Chapter_006'
 import XHTML16_CHAPTER_007 from '@/components/xhtml/16_Chapter_007'
 import XHTML17_CHAPTER_008 from '@/components/xhtml/17_Chapter_008'
 import XHTML18_CHAPTER_009 from '@/components/xhtml/18_Chapter_009'
 import XHTML19_CHAPTER_010 from '@/components/xhtml/19_Chapter_010'
 import XHTML20_CHAPTER_011 from '@/components/xhtml/20_Chapter_011'
 import XHTML21_CHAPTER_012 from '@/components/xhtml/21_Chapter_012'
 import XHTML22_CHAPTER_013 from '@/components/xhtml/22_Chapter_013'
 import XHTML23_CHAPTER_014 from '@/components/xhtml/23_Chapter_014'
 import XHTML24_CHAPTER_015 from '@/components/xhtml/24_Chapter_015'
 import XHTML25_CHAPTER_016 from '@/components/xhtml/25_Chapter_016'
 import XHTML26_CHAPTER_017 from '@/components/xhtml/26_Chapter_017'
 import XHTML27_CHAPTER_0E1 from '@/components/xhtml/27_Chapter_0E1'
 import XHTML28_CHAPTER_0E2 from '@/components/xhtml/28_Chapter_0E2'
 import XHTMLPLATE from '@/components/xhtml/plate'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/Title",
 			"name" : "xhtml/Title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/Copyright",
 			"name" : "xhtml/Copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/03_Map",
 			"name" : "xhtml/03_Map",
 			"component" : XHTML03_MAP
 		},
 		{
 			"path" : "/xhtml/04_Note",
 			"name" : "xhtml/04_Note",
 			"component" : XHTML04_NOTE
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgements",
 			"name" : "xhtml/05_Acknowledgements",
 			"component" : XHTML05_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/06_Glossary",
 			"name" : "xhtml/06_Glossary",
 			"component" : XHTML06_GLOSSARY
 		},
 		{
 			"path" : "/xhtml/07_Brief",
 			"name" : "xhtml/07_Brief",
 			"component" : XHTML07_BRIEF
 		},
 		{
 			"path" : "/xhtml/08_Opor",
 			"name" : "xhtml/08_Opor",
 			"component" : XHTML08_OPOR
 		},
 		{
 			"path" : "/xhtml/09_Military",
 			"name" : "xhtml/09_Military",
 			"component" : XHTML09_MILITARY
 		},
 		{
 			"path" : "/xhtml/10_Chapter_001",
 			"name" : "xhtml/10_Chapter_001",
 			"component" : XHTML10_CHAPTER_001
 		},
 		{
 			"path" : "/xhtml/11_Chapter_002",
 			"name" : "xhtml/11_Chapter_002",
 			"component" : XHTML11_CHAPTER_002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js